import React, { useState, useEffect } from "react";
import { Col, Row, Spin} from "antd";
import CurrencyFormat from "react-currency-format";
import Widgets from "./HomeCards/Card";
import RequestHandler from "util/RequestHandler";
import AccountBalanceTable from "./AkodeDashboard/AccountBalanceTable"
import AccountTransactionTable from "./AkodeDashboard/AccountTransactionTable"
import Widget from "components/Widget";


const HomePage = () => {
  const [accountTransactionCount, setAccountTransactionCount] = useState(0);
  const [totalGoing, setTotalGoing] = useState(0);
  const [totalIncoming, setTotalIncoming] = useState(0);
  const [totalCurrencyValue, setTotalCurrencyValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
    isAdmin: false,
  });
  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
    });
  }, []);
  useEffect(() => {
    RequestHandler.get(
      "/ToslaAccountBalance/GetDashboardStatistic"
    ).then((res) => {
      setTotalCurrencyValue(res.totalBalance);
      setTotalIncoming(res.totalIncoming)
      setTotalGoing(res.totalGoing)
      setAccountTransactionCount(res.accountCount)
      setLoading(false)
    });
  }, [
    setAccountTransactionCount,
    setTotalGoing,
    setTotalIncoming,
    permissions.loading,
  ]);
  const monthNames = [
    "OCAK",
    "ŞUBAT",
    "MART",
    "NİSAN",
    "MAYIS",
    "HAZİRAN",
    "TEMMUZ",
    "AĞUSTOS",
    "EYLÜL",
    "EKİM",
    "KASIM",
    "ARALIK",
  ];
  const date = new Date();

  const GetHomePage = () => (
    <div>
        <Spin spinning={loading} >
          <Row style={{ marginLeft: 2 }}>
            <Col span={24}>
              <div class="ant-row">
                <Widgets
                  icon="home"
                  currency={""}
                  title="BAKİYE"
                  totalBalance={
                    <CurrencyFormat
                      value={totalCurrencyValue}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={"₺"}
                    />
                  }
                />
                <Widgets
                  icon="long-arrow-up"
                  color="green"
                  title={`${monthNames[date.getMonth()]} AYI GELEN`}
                  currency={"TRY"}
                  totalBalance={
                    <CurrencyFormat
                      value={totalIncoming}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  }
                />
                <Widgets
                  icon="long-arrow-down"
                  totalBalance={
                    <CurrencyFormat
                      value={totalGoing}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  }
                  currency={"TRY"}
                  title={`${monthNames[date.getMonth()]} AYI GİDEN`}
                  color="red"
                />
                <Widgets
                  icon="data-entry"
                  totalBalance={
                    <CurrencyFormat
                      value={accountTransactionCount}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  }
                  currency={""}
                  title={`${monthNames[date.getMonth()]} AYI HAREKET SAYISI`}
                />
              </div>
            </Col>

            <Col xs={24} md={12} lg={12} >
              <div style={{textAlign:'center'}}> <h4><strong></strong></h4></div>
            </Col>
            <Col xs={24} md={12} lg={12}>
            <div style={{textAlign:'center'}}> <h4><strong> </strong></h4></div>
             
            </Col>

        
            <Col xs={24} md={12} lg={12} style={{marginTop:'3%'}}>
            
            <Widget title={
           <div style={{textAlign:'center'}}> <h4> Son işlemler </h4></div>
                } styleName="gx-card-ticketlist"
                  extra={<h5 className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
                
                  </h5>}>
                  <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
                    <Col span={24} style={{overflowY:'auto'}} >
                    <AccountTransactionTable />

                    </Col>
                  </div>
                 <div style={{textAlign:'center'}}> 
                 <a  style={{color:'#a70000'}} href="account-transaction">Tüm İşlemler</a>  <i
                    className="icon icon-long-arrow-right gx-fs-xxl gx-ml-2 gx-d-inline-flex gx-vertical-align-middle"/>
                 </div>
          </Widget>
              
            </Col>
            <Col xs={24} md={12} lg={12} style={{marginTop:'3%'}}>
            <Widget title={
                <div style={{textAlign:'center'}}> <h4>Son hesap hareketleri</h4></div>
                } styleName="gx-card-ticketlist"
                  extra={<h5 className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
                
                  </h5>}>
                  <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
                    <Col span={24} style={{overflowY:'auto'}} >
                    <AccountBalanceTable />

                    </Col>
                  </div>
                  <div style={{textAlign:'center'}}> 
                 <a style={{color:'#a70000'}} href="account-balance">Tüm Hesap Hareketleri</a>  <i
                    className="icon icon-long-arrow-right gx-fs-xxl gx-ml-2 gx-d-inline-flex gx-vertical-align-middle"/>
                 </div>
                 
          </Widget>
            </Col>
          </Row>
        </Spin>
    </div>
  );

  const RenderModulePage = () => {
    if (permissions.modules.includes(9)) {
      return GetHomePage();
    } 
  };

  return permissions.loading ? null : (
    <>
      {RenderModulePage()}
    </>
  );
};
export default HomePage;
